import Vue from "vue";

let enumURL = 'https://ota.dccllc.net/enum/enum-api.php';
const eNumDashboardService = {

    async getENumVersion() {
        let url = `${enumURL}?method=GetVersionInfo`;
        return Vue.axios.get(url);
    },

    async getConfig() {
        let url = `${enumURL}?method=GetConfigData`;
        return Vue.axios.get(url);
    },

    async updateConfig(param) {
        let url = `${enumURL}?method=UpdateConfigData`;
        return Vue.axios.post(url, param);
    },

    async addSingleNumber(param) {
        let url = `${enumURL}?method=AddSingleNumber&number=${param.msisdn}&domain=${param.domain}`;
        return Vue.axios.get(url);
    },

    async removeSingleNumber(number) {
        let url = `${enumURL}?method=RemoveSingleNumber&number=${number}`;
        return Vue.axios.get(url);
    },

    async querySingleNumber(number) {
        let url = `${enumURL}?method=QuerySingleNumber&number=${number}`;
        return Vue.axios.get(url);
    },

    async addNumberRange(param) {
        let url = `${enumURL}?method=AddNumberRange&start_number=${param.from}&end_number=${param.to}&domain=${param.domain}`;
        return Vue.axios.get(url);
    },

    async removeNumberRange(param) {
        let url = `${enumURL}?method=RemoveNumberRange&start_number=${param.from}&end_number=${param.to}`;
        return Vue.axios.get(url);
    },

    async listZoneFile() {
        let url = `${enumURL}?method=ListZoneFile`;
        return Vue.axios.get(url);
    },

    async listNumbers() {
        let url = `${enumURL}?method=ListNumbers`;
        return Vue.axios.get(url);
    },

    async exportCSVFile() {
        let url = `${enumURL}?method=ListNumbers&hideheader=1`;
        return Vue.axios.get(url);
    },

    async loadCSV(param) {
        let url = `${enumURL}?method=LoadCSV&csvfile=${param}`;
        return Vue.axios.get(url);
    },

    async moveUpLoadedFile(file) {
        let formData = new FormData();
        formData.append("file", file)
        let url = `${enumURL}?method=MoveUploadedFile`;
        return Vue.axios.post(url, formData);
    }
}

export default eNumDashboardService;